module.exports = __webpack_public_path__ + "static/img/legend_xa_dark_vertical.fdda0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_dark_vertical.png
// module id = oxTJ
// module chunks = 94